import axios from "./axios";

export const verifyEmail = async (token) => {
  return await axios.post("/email-verification/verify", undefined, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const resendEmail = async (email) => {
  return await axios.post("/email-verification/resend", {email});
};
